import { FC } from "react";

import { TicketingFormCategory } from "@simplyk/common";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export interface ThemedGroupTicketCaptionProps {
  count: number;
  formCategory: TicketingFormCategory;
}

export const ThemedGroupTicketCaption: FC<ThemedGroupTicketCaptionProps> = ({ count, formCategory }) => {
  const { t } = useTranslate();

  const isRaffle = formCategory === TicketingFormCategory.Lottery;

  return (
    <FormTypography variant="body2" component="span" vibe="brand">
      {t("ticketing", isRaffle ? "groupTicketCaptionRaffle" : "groupTicketCaption", { count })}
    </FormTypography>
  );
};
